var _path, _path2, _circle, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLiftback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 22,
    viewBox: "0 0 72 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3971 18.7683C18.6747 18.0725 18.8273 17.3134 18.8273 16.5186C18.8273 13.1635 16.1074 10.4436 12.7522 10.4436C9.39709 10.4436 6.6772 13.1635 6.6772 16.5186C6.6772 17.3151 6.83047 18.0757 7.10912 18.7727C5.62579 19.1206 2.42819 19.3913 1.35271 17.7183C0.00270432 15.6183 0.302706 12.2433 1.35271 11.6433C1.52051 11.5474 1.69022 11.4438 1.86797 11.3354L1.86806 11.3353L1.86811 11.3353L1.86819 11.3352C2.8027 10.7651 3.95941 10.0593 6.22777 9.61824C7.16591 9.43582 8.35757 9.26246 9.59512 9.08243C11.9193 8.74431 14.4054 8.38264 15.6778 7.89323C16.3675 7.62796 17.9419 6.74464 19.8149 5.69372C23.2377 3.77327 27.658 1.29317 29.5 1.00233C32.35 0.552327 48.55 0.477223 52 1.00223C55.45 1.52723 64.5 4.50232 66.2282 5.49326H70.2032V7.89323L70.6532 11.7933L71.6282 12.6183V16.8933C70.1782 17.4183 66.2732 18.4233 62.2532 18.2433C62.1478 18.2386 62.0413 18.2343 61.9338 18.2305C62.0929 17.6875 62.1783 17.113 62.1783 16.5186C62.1783 13.1635 59.4584 10.4436 56.1033 10.4436C52.7481 10.4436 50.0282 13.1635 50.0282 16.5186C50.0282 17.3055 50.1778 18.0574 50.4501 18.7475C50.382 18.7545 50.3163 18.7615 50.2531 18.7683H18.3971ZM61.2776 6.54268C60.3573 6.73643 57.257 4.95549 54.6757 3.47269L54.6754 3.47255L54.6751 3.47233L54.6742 3.47181C54.0585 3.11816 53.4724 2.78149 52.9525 2.49265C52.9525 2.49265 64.2494 5.75241 63.9994 6.00241C63.845 6.15679 63.2782 6.235 62.5987 6.32875C62.1778 6.38683 61.7136 6.45087 61.2776 6.54268ZM21.7501 7.37676C22.9001 6.27675 28.3236 3.51294 29.7036 3.09294C31.4287 2.56794 35.8537 2.26793 37.5787 2.26793C39.3037 2.26793 47.4038 2.34293 48.9788 2.71794C50.5538 3.09294 55.8753 6.47675 56.4003 6.85175C51.9107 7.39595 35.0201 7.38487 24.6981 7.3781C23.6395 7.37741 22.65 7.37676 21.7501 7.37676Z",
    fill: "#BABABA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6888 8.80791L38.9593 1.89279",
    stroke: "#BABABA",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.8305,
    cy: 16.5921,
    r: 4.05003,
    stroke: "#BABABA",
    strokeWidth: 2.10001
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.1782,
    cy: 16.5921,
    r: 4.05003,
    stroke: "#BABABA",
    strokeWidth: 2.10001
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiftback);
export default ForwardRef;